/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DataLeak,
  PaginatedDataLeakList,
  PatchedDataLeak,
} from '../models/index';
import {
    DataLeakFromJSON,
    DataLeakToJSON,
    PaginatedDataLeakListFromJSON,
    PaginatedDataLeakListToJSON,
    PatchedDataLeakFromJSON,
    PatchedDataLeakToJSON,
} from '../models/index';

export interface DataLeaksListRequest {
    teamSlug: string;
    limit?: number;
    ordering?: string;
    page?: number;
    search?: string;
}

export interface DataLeaksRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface SecretsCreateRequest {
    teamSlug: string;
    dataLeak: Omit<DataLeak, 'id'|'created_at'|'updated_at'>;
}

export interface SecretsDestroyRequest {
    id: string;
    teamSlug: string;
}

export interface SecretsGitRepositoriesRetrieveRequest {
    teamSlug: string;
}

export interface SecretsPartialUpdateRequest {
    id: string;
    teamSlug: string;
    patchedDataLeak?: Omit<PatchedDataLeak, 'id'|'created_at'|'updated_at'>;
}

export interface SecretsStatisticsRetrieveRequest {
    teamSlug: string;
}

export interface SecretsUpdateRequest {
    id: string;
    teamSlug: string;
    dataLeak: Omit<DataLeak, 'id'|'created_at'|'updated_at'>;
}

/**
 * 
 */
export class SecretsApi extends runtime.BaseAPI {

    /**
     */
    async dataLeaksListRaw(requestParameters: DataLeaksListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDataLeakList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling dataLeaksList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/secrets/{team_slug}/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDataLeakListFromJSON(jsonValue));
    }

    /**
     */
    async dataLeaksList(requestParameters: DataLeaksListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDataLeakList> {
        const response = await this.dataLeaksListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async dataLeaksRetrieveRaw(requestParameters: DataLeaksRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataLeak>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling dataLeaksRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling dataLeaksRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/secrets/{team_slug}/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DataLeakFromJSON(jsonValue));
    }

    /**
     */
    async dataLeaksRetrieve(requestParameters: DataLeaksRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DataLeak> {
        const response = await this.dataLeaksRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async secretsCreateRaw(requestParameters: SecretsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataLeak>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling secretsCreate().'
            );
        }

        if (requestParameters['dataLeak'] == null) {
            throw new runtime.RequiredError(
                'dataLeak',
                'Required parameter "dataLeak" was null or undefined when calling secretsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/secrets/{team_slug}/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DataLeakToJSON(requestParameters['dataLeak']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DataLeakFromJSON(jsonValue));
    }

    /**
     */
    async secretsCreate(requestParameters: SecretsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DataLeak> {
        const response = await this.secretsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async secretsDestroyRaw(requestParameters: SecretsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling secretsDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling secretsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/secrets/{team_slug}/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async secretsDestroy(requestParameters: SecretsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.secretsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Get statistics about git repository leaks
     */
    async secretsGitRepositoriesRetrieveRaw(requestParameters: SecretsGitRepositoriesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataLeak>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling secretsGitRepositoriesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/secrets/{team_slug}/git_repositories/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DataLeakFromJSON(jsonValue));
    }

    /**
     * Get statistics about git repository leaks
     */
    async secretsGitRepositoriesRetrieve(requestParameters: SecretsGitRepositoriesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DataLeak> {
        const response = await this.secretsGitRepositoriesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async secretsPartialUpdateRaw(requestParameters: SecretsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataLeak>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling secretsPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling secretsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/secrets/{team_slug}/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedDataLeakToJSON(requestParameters['patchedDataLeak']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DataLeakFromJSON(jsonValue));
    }

    /**
     */
    async secretsPartialUpdate(requestParameters: SecretsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DataLeak> {
        const response = await this.secretsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get overall statistics about data leaks
     */
    async secretsStatisticsRetrieveRaw(requestParameters: SecretsStatisticsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataLeak>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling secretsStatisticsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/secrets/{team_slug}/statistics/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DataLeakFromJSON(jsonValue));
    }

    /**
     * Get overall statistics about data leaks
     */
    async secretsStatisticsRetrieve(requestParameters: SecretsStatisticsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DataLeak> {
        const response = await this.secretsStatisticsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async secretsUpdateRaw(requestParameters: SecretsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataLeak>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling secretsUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling secretsUpdate().'
            );
        }

        if (requestParameters['dataLeak'] == null) {
            throw new runtime.RequiredError(
                'dataLeak',
                'Required parameter "dataLeak" was null or undefined when calling secretsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/secrets/{team_slug}/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DataLeakToJSON(requestParameters['dataLeak']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DataLeakFromJSON(jsonValue));
    }

    /**
     */
    async secretsUpdate(requestParameters: SecretsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DataLeak> {
        const response = await this.secretsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
